import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CaseNumberTooltip from '../tooltips/caseNumberTooltip/CaseNumberTooltip';

class CaseNumberSelector extends Component {
  render() {
    const clsName = (this.props.showFlash) ? 'input-search x-closeable flash-yellow' : 'input-search  x-closeable';

    return (
      <div className="form-item" style={{ display: 'inline-block', width: 'auto' }}>
        <label htmlFor="case-number">Case Number: <CaseNumberTooltip /></label>
        <input type="search"
               maxLength="128"
               id="case-number"
               size="60"
               ref="case_no"
               onChange={this.props.onChange}
               value={this.props.value}
               className={clsName} />
      </div>
    );
  }
}

CaseNumberSelector.propTypes = {
  showFlash: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.string,
};

CaseNumberSelector.defaultProps = {
  showFlash: false,
  value: '',
  onChange: () => null,
};


export default CaseNumberSelector;


// WEBPACK FOOTER //
// ./src/components/search/FormElements/caseSelector/CaseNumberSelectorOfCaseLookup.jsx